<form [uiDisable]="disabled" name="form" #f="ngForm" [ngClass]="classType" (ngSubmit)="onSubmit(f)"
      ngModelOptions="{timezone: 'America/Chicago}" novalidate autocomplete="off">
  <ng-content></ng-content>
</form>
